/* global Prototype */
(function(Prototype) {

    // Fix prototype array toJSON override
    var Fixer = {
        fix: function() {
            for (var key in this) {
                if (key != 'fix') {
                    this[key]();
                }
            }
        },

        fixArrayToJson: function() {
            if (typeof Prototype === 'undefined' || parseFloat(Prototype.Version.substr(0,3)) >= 1.7 || typeof Array.prototype.toJSON === 'undefined') {
                return;
            }

            var _json_stringify = JSON.stringify;
            JSON.stringify = function(value) {
                var _array_tojson = Array.prototype.toJSON;
                delete Array.prototype.toJSON;
                var r=_json_stringify(value);
                Array.prototype.toJSON = _array_tojson;
                return r;
            };
        }
    };

    // Execute all fixing methods
    Fixer.fix();

})(window.Prototype);
